import instance from 'api/globalaxios';
import { gethost } from 'slices/disputeSlice';

export async function getClaimantAnswerData(id) {
  return await instance({
    method: 'get',
    url: '/claimantanswerdata/' + id + '/',
  });
}

export async function getCaseFiles(id) {
  return await instance({
    method: 'get',
    url: 'api/casefiles/' + id + '/',
  });
}

export async function getCaseTimeline(id) {
  return await instance({
    method: 'get',
    url: `api/timeline/?id=${id}`,
  });
}

export async function getMuthootdatabydate(date, cancelToken, type=null, region=null) {
  return await instance.get(
    `api/muthootsearchbydateView/${date}/?type=${type}&region=${region}`,
    { cancelToken: cancelToken?.token }
  );
}

export async function getMuthootdatabyDisputeId(value, cancelToken, type=null, region=null, days=null) {
  return await instance.get(
    `/api/muthootsearchbydisputeidView/${value}/?type=${type}&region=${region}&days=${days}`,
    { cancelToken: cancelToken?.token }
  );
}

export async function getMuthootdatabyname(firstname, lastname, cancelToken, type=null, region=null, days=null) {
  const url = lastname ? `/api/MuthootsearchView/${firstname}/${lastname}/?type=${type}&region=${region}&days=${days}` : `/api/MuthootsearchView/${firstname}/${null}/?type=${type}&region=${region}&days=${days}`;
  return await instance.get(url, { cancelToken: cancelToken?.token });
}

export async function getMuthootMailTrail(disputeId) {
  return await instance({
    method: 'get',
    url: `/muthoot/${disputeId}/mail-trail/`,
    responseType: 'blob',
    // The error body is a Blob here, so the global handler cannot render it and
    // a failed row download should not redirect the whole listing to /fallback.
    suppressGlobalErrorHandling: true,
  });
}

export async function getMuthootResponsibleDepartments() {
  return await instance({
    method: 'get',
    url: '/muthoot-department-dropdown/',
  });
}

export async function fetchMuthootRegions() {
  const response = await instance({
    method: "get",
    url: `api/muthoot-regions/`,
  });
  return response.data;
};

export async function fetchMuthootbranches(url, searchText = "") {
  const response = await instance({
    method: "get",
    url: url,
    params: {
      host: gethost(),
      search_text: searchText,
    }
  });
  return response.data;
};
